/**
 * Централизованные константы для заказов
 * Следует принципу DRY - единственный источник истины
 */
export const ORDER_STATUSES = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PREPARING: 'preparing',
  READY: 'ready',
  DELIVERY: 'delivery',
  DELIVERED: 'delivered',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const

export const PAYMENT_STATUSES = {
  WAITING: 'waiting',      // Начальный статус при создании платежа
  PENDING: 'pending',      // Промежуточный для двухстадийных платежей
  SUCCEEDED: 'succeeded',  // Финальный успешный статус
  PAID: 'paid',           // Оплачено (legacy)
  FAILED: 'failed',       // Платеж не прошел
  CANCELLED: 'cancelled', // Платеж отменен
  REFUNDED: 'refunded',   // Возврат средств
} as const

export const PAYMENT_TIMEOUT_MINUTES = 15

export const TIMER_URGENCY_THRESHOLDS = {
  CRITICAL: 1, // 1 минута
  URGENT: 5,   // 5 минут
} as const

export type OrderStatus = typeof ORDER_STATUSES[keyof typeof ORDER_STATUSES]
export type PaymentStatus = typeof PAYMENT_STATUSES[keyof typeof PAYMENT_STATUSES]
